import camelCase from 'lodash/camelCase';
import { MenuIdProjects } from '@jira/navigation-apps__constants/src/MenuIdProjects.tsx';
import { SidebarIdProjectSettings } from '@jira/navigation-apps__constants/src/SidebarIdProjectSettings.tsx';
import { playbooksListRequestTypesResource } from '@jira/router-resources__playbooks-list-screen/src/playbooksListRequestTypesResource.tsx';
import { playbooksListWorkTypesResource } from '@jira/router-resources__playbooks-list-screen/src/playbooksListWorkTypesResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import playbookListOnlyEntryPoint from '@jira/spa-apps__project-settings-playbooks-list-only-view/src/playbookListOnlyViewEntryPoint.entrypoint.tsx';
import playbooksHorizontalNavEntrypoint from '@jira/spa-apps__project-settings-playbooks-horizontal-nav/src/playbooksHorizontalNavEntrypoint.entrypoint.tsx';
import ErrorPagesNotFound from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { notFoundPageEntrypoint } from '@jira/router-routes__not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { getConsolidationStateResource } from '@jira/router-resources__eoc-tenant-info/src/getConsolidationStateResource.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getServiceDeskSettingsResources } from '@jira/router-resources__service-desk-common/src/getServiceDeskSettingsResources.tsx';
import { servicedeskPlaybooksListOnlyRoute } from '@jira/router-routes__project-settings-playbooks-routes/src/servicedeskPlaybooksListOnlyRoute.tsx';
import { serviceProjectLayout } from '@jira/platform__layouts-service-project-layout/src/index.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { isFeatureEnabled } from '@atlassiansox/frontend-feature-encoding';
// eslint-disable-next-line jira/restricted/fedramp-isolated-cloud
import { isFedRamp } from '@atlassian/atl-context';
import { PlaybookListLoadingView } from '@jira/playbooks__list-screen/src/PlaybookListLoadingView.tsx';
import type { Route } from '@atlassian/react-resource-router';

const listOnlyEntryPoint = createPageEntryPoint({
	main: playbookListOnlyEntryPoint,
	horizontalNavigation: playbooksHorizontalNavEntrypoint,
});

export const servicedeskPlaybooksListOnlyRouteEntry: Route = createEntry(
	servicedeskPlaybooksListOnlyRoute,

	() => ({
		group: 'project-settings-servicedesk',
		layout: serviceProjectLayout,

		navigation: {
			menuId: MenuIdProjects,
			sidebarId: SidebarIdProjectSettings,
		},

		entryPoint() {
			if (
				fg('aem_rr_playbooks')
					? !isFeatureEnabled('jira-service-management', 'jsm-automation-playbook')
					: isFedRamp()
			) {
				return notFoundPageEntrypoint;
			}
			return listOnlyEntryPoint;
		},

		resources: [
			...getServiceDeskSettingsResources(),
			getConsolidationStateResource(),
			playbooksListRequestTypesResource,
			resourceWithCondition(
				() => fg('phantom-5397_playbook_work_type_column'),
				playbooksListWorkTypesResource,
			),
		],

		meta: {
			reporting: {
				id: 'project-settings.playbooks.list-only-view',
				packageName: camelCase('project-settings-playbooks-list-only'),
				teamName: 'ITOps Phantom',
			},
		},

		// eslint-disable-next-line no-restricted-syntax
		component: ErrorPagesNotFound,
		ufoName: 'playbook-list-only',
		skeleton: PlaybookListLoadingView,

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
